import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import { Colors } from '@kp/react-ui';
import { createClasses } from '../../utils/css';
import { Layout } from '../Layout';

const classes = createClasses({
  root: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  wrapper: {
    textAlign: 'center',
  },
});

export interface LoaderProps {}

export const Loader: React.FC<LoaderProps> = () => (
  <Layout className={classes.root}>
    <div className={classes.wrapper}>
      <TailSpin color={Colors.Neutral.iconWeak} height={100} width={100} />
    </div>
  </Layout>
);
